import { I } from './icons';

type SlashPopoverProps = {
  active?: number;
};

export function SlashPopover({ active = 0 }: SlashPopoverProps) {
  const items = [
    { ic: <I.tts />, name: '/tts', desc: '메시지를 음성으로 읽어줘요' },
    { ic: <I.sparkle />, name: '/이모지', desc: '이모지를 고화질로 업스케일' },
    { ic: <I.globe />, name: '/번역', desc: '108개 언어로 자동 번역' },
    { ic: <I.music />, name: '/재생', desc: '유튜브·사운드클라우드 음악' },
    { ic: <I.hand />, name: '/환영', desc: '환영 메시지·카드를 설정' },
  ];
  return (
    <div className="slash-pop">
      <div className="head">
        <span><b>카미봇 명령어</b> · 23개 더 있어요</span>
        <span>↑↓ · enter</span>
      </div>
      <ul>
        {items.map((it, i) => (
          <li key={i} className={i === active ? 'active' : ''}>
            <span className="ic">{it.ic}</span>
            <span>
              <span className="name">{it.name}</span>
              <span className="desc">{it.desc}</span>
            </span>
            <span className="key">tab</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
